module.exports = __webpack_public_path__ + "img/calendar-date.28622490.svg";